import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { IconTick } from '@xingternal/icons';
import { Marker, MarkerVariant } from '@xingternal/marker';
import { spaceL, spaceXL } from '@xingternal/tokens';

import { useHeaderContext } from '../../context';
import { FormattedSalary } from '../formatted-salary';

export const HighlightsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceL};
  margin-bottom: ${spaceXL};
`;

type Props = { label?: string; icon?: React.FC<React.SVGProps<SVGSVGElement>>; variant?: MarkerVariant };

const Highlight: React.FC<Props> = ({ label, variant, icon, children }) => (
  <Marker variant={variant} icon={icon}>
    {label ? <FormattedMessage id={label} /> : null}
    {children ? children : null}
  </Marker>
);

export const Highlights: React.FC = () => {
  const { remoteOptionKey, matchingJobAgeKey, isApplyWithoutDocuments, isMatchingSalary, salary } = useHeaderContext();

  return (
    <HighlightsWrapper>
      {isMatchingSalary && salary ? (
        <Highlight variant="match" icon={IconTick}>
          <FormattedSalary salary={salary} />
        </Highlight>
      ) : null}
      {remoteOptionKey ? <Highlight label={remoteOptionKey} /> : null}
      {isApplyWithoutDocuments ? <Highlight label="JOBS_INSTANT_XING_APPLY_FLAG" /> : null}
      {matchingJobAgeKey ? <Highlight label={matchingJobAgeKey} /> : null}
    </HighlightsWrapper>
  );
};
